import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY)

const StripeProvider = ({ children, options }) => {
    return (
        <Elements stripe={stripePromise} options={options}>
            {children}
        </Elements>
    )
}

export default StripeProvider
